// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Ve","title":"We","nav":"Xe","flexCell":"Ye","facetLink":"Ze"};